<div mat-dialog-title>
    <div flex fxLayout="row" class="justify-content-center">
        <div class="ml-2">
            <span class="mat-display-1" *ngIf="updateReserva">Actualizar Reserva Recurrente</span>
            <span class="mat-display-1" *ngIf="!updateReserva">Nueva Reserva Recurrente</span>
        </div>
    </div>
</div>

<div class="first-form d-flex justify-content-center">
    <form #f="ngForm">
        <div *ngIf="changeStep">
            <div mat-dialog-content>
                <table class="table text-muted">
                    <tr>
                        <td>Días:</td>
                        <td>
                            <mat-form-field>
                                <mat-select [(ngModel)]="selected_weekdays" [ngModelOptions]="{standalone: true}"
                                    multiple (selectionChange)="onSelectionChange($event)">
                                    <mat-option *ngFor="let day of days; let i = index" [value]="i">
                                        {{ day }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td>
                          <mat-label>Fecha de inicio:</mat-label>
                        </td>
                        <td class="d-flex">
                          <input matInput [matDatepicker]="startPicker" [formControl]="f_date"
                            (dateChange)="setMinEndDate()" class="input-date" [value]="startDate">
                          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                          <mat-datepicker #startPicker></mat-datepicker>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <mat-label>Fecha de fin:</mat-label>
                        </td>
                        <td class="d-flex">
                          <input matInput [matDatepicker]="endPicker" [formControl]="end_date_control"
                            [min]="minEndDate" class="input-date" [value]="endDate">
                          <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                          <mat-datepicker #endPicker></mat-datepicker>
                        </td>
                      </tr>
                    <tr>
                        <td>Tamaño del partido:</td>
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="reserva.field_capacity" name="field_capacity" #field_capacity="ngModel" required>
                            <mat-option *ngFor="let size of fieldSizes" [value]="size.description">{{size.display_description}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="field_capacity.invalid">Debe seleccionar la cantidad de jugadores</mat-error>
                    </mat-form-field>
                </td>
                    <tr>
                        <td>Turno:</td>
                        <td>
                          <mat-form-field>
                            <mat-select name="turno" [(ngModel)]="f_turno"  [value]="f_turno" (ngModelChange)="onHourSelect()" required>
                              <mat-option *ngFor="let shift of openShifts" [value]="shift">{{shift}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                      </tr>
                    <tr>
                        <td>Descripción:</td>
                        <td>
                            <mat-form-field>
                                <input matInput name="descripcion" [(ngModel)]="reserva.description"
                                    placeholder="Descripcion" type="text" rows="4">
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td>Datos Contacto:</td>
                        <td>
                            <mat-form-field>
                                <input matInput name="name" [(ngModel)]="reserva.name" placeholder="Nombre" required>
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <mat-form-field>
                                <input matInput name="phone" [(ngModel)]="reserva.phone" type="number"
                                    placeholder="Teléfono" required>
                            </mat-form-field>
                        </td>
                    </tr>
                </table>
            </div>
            <div mat-dialog-actions align="end" class="d-flex">
                <button mat-button [mat-dialog-close]>Cerrar</button>
                <button mat-raised-button mat-raised-button color="primary" (click)="changeStep = false"
                    [disabled]="!f.valid" (click)="listAvailableFunc()">Siguiente</button>
            </div>
        </div>

        <div class="container-second-form" *ngIf="!changeStep">
            <div class="second-form mt-5 mb-5">
                <div class="available">
                    <h2 class="m-0">Disponibles</h2>
                    <hr color="green">
                    <div class="list-available">
                        <div *ngFor="let item of listAvailable">
                            <p>
                                {{formatDate(item.date)}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="unailable">
                    <h2 class="m-0">No disponibles</h2>
                    <hr color="red">
                    <div class="list-unavailable">
                        <div *ngFor="let item of listUnavailable">
                            <p>
                                {{formatDate(item.date)}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div mat-dialog-actions align="end" class="d-flex">
                <button mat-button (click)="changeStep = true">Atras</button>
                <button mat-raised-button mat-raised-button color="primary" (click)="onSubmitConfirmation()"
                    [disabled]="clickDouble">Reservar Turno</button>
            </div>
        </div>
    </form>
</div>